module.exports = __webpack_public_path__ + "static/img/ex_t1.b5802a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_t1.jpg
// module id = nRDd
// module chunks = 1